import { useEffect } from 'react';
import {
  isRouteErrorResponse,
  useLocation,
  useNavigate,
  useRouteError,
} from 'react-router-dom';

import { Button, ButtonVariant } from '@/components/form/button';

export const NotFoundErrorPage = () => {
  const error = useRouteError();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname } = location;

    // check whether the route is an old webapp route, if so redirect to home
    const isAnOldROute = pathname.includes('/fw') || pathname.includes('/bb');

    if (isRouteErrorResponse(error) && error.status === 404 && isAnOldROute) {
      navigate('/');
    }
  }, [error]);

  return (
    <div className="flex flex-col justify-center min-h-screen items-center">
      <div>
        <div className="mt-10">
          <h1 className="text-2xl font-bold text-gray-600">Whoops!</h1>
          <h3 className="text-medium font-thin text-gray-600">
            Sorry, we couldn&apos;t find the page you&apos;re looking for
          </h3>
        </div>
        <div className="mt-10 flex gap-5">
          <Button
            variant={ButtonVariant.Primary}
            onClick={() => (window.location.href = '/')}
          >
            Go back home
          </Button>
          <Button
            variant={ButtonVariant.Secondary}
            onClick={() => window.open('https://www.oculyze.net/contact', '_blank')}
          >
            Report Problem
          </Button>
        </div>
      </div>

      <div className="absolute bottom-5 text-xs md:w-1/4 p-5 bg-gray-100 text-gray-600 rounded-lg">
        <p className="font-medium mb-2">Error</p>
        <p className="font-thin">{(error as any).statusText || (error as any).message}</p>
      </div>
    </div>
  );
};
